import './App.css';

function App() {
  return (
    <main className="coming-soon">
      <h1>COMING SOON</h1>
    </main>
  );
}

export default App;
